import React, { ReactNode } from 'react'

import styles from './styles.module.css'

const UspBadge = ({
  text,
  variant = 'yellow-primary',
  className = '',
  icon = null,
  as = 'span',
  children = null
}: {
  text: string
  variant?:
    | 'yellow-primary'
    | 'yellow-secondary'
    | 'blue-primary'
    | 'black-primary'
    | 'next-gen-green'
    | 'next-gen-blue'
  className?: string
  icon?: ReactNode
  as?: 'span' | 'li'
  children?: ReactNode
}) => {
  const Tag = as

  return (
    <Tag className={`${styles.badge} ${className}`} data-variant={variant}>
      {icon}
      {text}
      {children}
    </Tag>
  )
}

export default UspBadge
